module.exports = __webpack_public_path__ + "static/media/Client2RanchoLogo.69c6cbee.png";